export const skills = [
  "VMware & Lab Environments",
  "VAPT & Pen Testing",
  "Office IT Hardware Setup",
  "Endpoint Management",
  "Docker & Kubernetes",
  "Incident Forensics & IR",
  "Compliance Frameworks",
  "Data Privacy & GDPR",
];